var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$root.token
    ? _c(
        "b-container",
        [
          _c("br"),
          _vm._v(" "),
          _c("h3", [_vm._v("SMART Goal Setting Sessions")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-tabs",
            {
              model: {
                value: _vm.tabIndex,
                callback: function($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex"
              }
            },
            [
              _c(
                "b-tab",
                { attrs: { title: "Search SMART Goals" } },
                [
                  _c("smart-goal-search", {
                    on: {
                      "edit-session": function($event) {
                        _vm.sessionToEdit = $event
                        _vm.tabIndex = 1
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Enter SMART Goals" } },
                [
                  _c("smart-goal-add-edit", {
                    attrs: { "session-to-edit": _vm.sessionToEdit }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fde8cf3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fde8cf3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/GoalSetting.vue
// module id = null
// module chunks = 